import { useEffect } from 'react';

export default (
  emailAddress: string,
  setEmailAddress: (value: React.SetStateAction<string>) => void,
  enabled = true,
) => {
  useEffect(() => {
    if (enabled) {
      setEmailAddress(emailAddress);
    }
  }, [setEmailAddress, emailAddress, enabled]);
};
